// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { ArticleUsageVO, ArticleVO } from '../model/vo/article.vo';
import { Log } from '@shared/debug/log';
import { ArticleManager } from './article.manager';
import { Observable } from 'rxjs';
import { ArticleDataService } from '../service/article-data.service';
import { ArticleAccessoryManager } from './article-accessory.manager';
import { ProjectArticleService } from '@project/service/project-article.service';
import { ApplicationRefreshService } from '@services/application-refresh.service';
import { AttachArticleUsageService } from '@project/service/attach-article-usage.service';

@Injectable({providedIn: 'root'})
export class MiniTerminalBlocksArticleManager {

  constructor(
    private articleManager: ArticleManager,
    private articleDataService: ArticleDataService,
    private projectArticleService: ProjectArticleService,
    private articleAccessoryManager: ArticleAccessoryManager,
    private applicationRefreshService: ApplicationRefreshService,
    private attachArticleUsageService: AttachArticleUsageService
  ) {}

  public async quickLoadArticle(message: any): Promise<void> {
    try {
      const article: ArticleVO = await this.quickLoadArticleAsObservable(message.data, message.quickLoadType).toPromise();
      this.articleManager.addArticleToCache(article);
      await this.quickLoadArticleHandler(article);
      this.articleAccessoryManager.checkAccessoryInfoByArticle(article);
    } catch (error) {
      Log.error('Could not quick load article: ', error);
      throw error;
    }
  }

  private async quickLoadArticleHandler(article: ArticleVO): Promise<void> {
    const usage: ArticleUsageVO = this.projectArticleService.createNewArticleUsage(article.identity, article.version);
    await this.attachArticleUsageService.attachArticleUsageToProject(usage, null, false);
    await this.applicationRefreshService.refreshProject();
  }

  private quickLoadArticleAsObservable(data: any, quickLoadType: number): Observable<ArticleVO> {
    if (quickLoadType === ArticleManager.QUICK_LOAD_TYPE_LOAD_BY_ARTICLE_NO) {
      return this.articleDataService.loadArticleByArticleNumber(data);
    } else if (quickLoadType === ArticleManager.QUICK_LOAD_TYPE_LOAD_BY_ARTICLE_TYPE) {
      return this.articleDataService.loadArticleByArticleType(data);
    } else {
      return this.articleDataService.loadArticleByArticleId(data);
    }
  }
}
